import React from 'react';
import gif from '../../gif/giphy (1).gif';
import bg from '../../gif/SL-092619-23740-28.jpg';


const Banner = () => {
    return (
        <div style={{
            background:`url(${bg})`
        }} className='w-full flex justify-center ' >
        
    <img className='' src={gif} alt="" />
   
   
        



          
        </div>
    );
};

export default Banner;